import React from 'react';
import { Accordion} from 'react-bootstrap';
import { useLanguage } from '../../Contexts/LanguageContext';
import './Faqs.scss';

const Faqs = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const sectionTitle = data.faqSection.heading;
  const accordianList= data.faqSection.accordionItems;

  const renderContent = (content) => {
    // If it's an array of objects -> render table
    if (
      Array.isArray(content) &&
      content.length > 0 &&
      typeof content[0] === 'object'
    ) {
      return (
        <div className="severity-table-wrap">
          <table className="severity-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Description (inches)</th>
                <th>Metric (cm)</th>
              </tr>
            </thead>
            <tbody>
              {content.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.code}</td>
                  <td>{row.description}</td>
                  <td>{row.metric}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    // Otherwise assume array of strings -> render paragraphs
    return content.map((text, idx) => <p key={idx}>{text}</p>);
  };


  return (
    <>      
       <div className="section-spacing faq-section">
          <h2>{sectionTitle}</h2>
          <Accordion>
            {accordianList.map((item, index) => (
              <Accordion.Item key={index} eventKey={index.toString()}>
                <Accordion.Header as="h4">{item.accordianTitle}</Accordion.Header>
                <Accordion.Body>
                {renderContent(item.accordianContent)}             
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
    </>
  );
};

export default Faqs;
